module.exports = __webpack_public_path__ + "img/Trophy Cup Table03.a75e3621.jpg";